import { DATA_TYPES, STORE_ORDER_STATUS } from "src/config/constants";
import StringUtil from "./StringUtil";

class ConvertUtil {

  static getOrderStatusText(status) {
    switch (status) {
      case STORE_ORDER_STATUS.PENDING: return "待支付";
      case STORE_ORDER_STATUS.PAYED: return "已付款";
      case STORE_ORDER_STATUS.CANCELED: return "已取消";
      case STORE_ORDER_STATUS.SENDED: return "已发货";
      case STORE_ORDER_STATUS.FINISHED: return "已完结";
      case STORE_ORDER_STATUS.REFUNDING: return "退款中";
      case STORE_ORDER_STATUS.REFUNDED: return "已退款";
      case STORE_ORDER_STATUS.SENDING: return "待发货";
      case STORE_ORDER_STATUS.DELETED: return "已删除";
      case STORE_ORDER_STATUS.TIMEOUT: return "已超时";
      case STORE_ORDER_STATUS.BANKPAYED: return "支付待确认";
    }
  }

  static getOrderStatusColor(status) {
    switch (status) {
      case STORE_ORDER_STATUS.PENDING:
      case STORE_ORDER_STATUS.REFUNDING:
      case STORE_ORDER_STATUS.BANKPAYED:
        return "error";
      case STORE_ORDER_STATUS.PAYED:
        return "success";
      case STORE_ORDER_STATUS.CANCELED:
      case STORE_ORDER_STATUS.REFUNDED:
      case STORE_ORDER_STATUS.DELETED:
      case STORE_ORDER_STATUS.TIMEOUT:
        return "default";
      case STORE_ORDER_STATUS.SENDED:
      case STORE_ORDER_STATUS.FINISHED:
        return "success";
      default:
        return "success";
    }
  }

  static getSignedAmount(type, amount) {
    let sign = '';
    switch (type) {
      case 0: 
      case 2: 
      case 3: 
        sign = '+'; break;
      case 1: sign = '-'; break;
    }

    return sign + StringUtil.trimZero(amount);
  }

  static getConstantValue(type, value) {
    switch (type) {
      case DATA_TYPES.NUMBER: return JSON.parse(value);
      //   break;
      // case DATA_TYPES.FLOAT: return JSON.parse(value);;
      case DATA_TYPES.BOOLEAN: break;
      case DATA_TYPES.STRING: break;
    }

  }

}

export default ConvertUtil;